export default {
  install(Vue) {
      Vue.prototype.$domainsList = [
          { value: 'https://zaimi-u-menya.ru', name: 'zaimi-u-menya.ru' },
          { value: 'https://myfinora.ru', name: 'myfinora.ru' },
          { value: 'https://express-zaimi.ru', name: 'express-zaimi.ru' },
          { value: 'https://zaimy-russia.ru', name: 'zaimy-russia.ru' },
          { value: 'https://mikrozaim--online.ru', name: 'mikrozaim--online.ru' },
          { value: 'https://mikrozaem-na-kartu.ru', name: 'mikrozaem-na-kartu.ru' },
          { value: 'https://zaimy-dlya-vseh.ru', name: 'zaimy-dlya-vseh.ru' },
          { value: 'https://microkredit-online.ru', name: 'microkredit-online.ru' },
          { value: 'https://adminkakonstruktorvitrin.ru', name: 'adminkakonstruktorvitrin.ru' },
      ];
  }
};